<button tabindex="-1" nz-button nzType="text" nzSize="small" type="button" nz-tooltip="Configurações do campo" (click)="openConfiguration($event)">
  <nz-icon nzType="tool"></nz-icon>
</button>
